module.exports = __webpack_public_path__ + "static/user-9a1e268cc5f6252bd673f95d5e2c61e9.jpg";